import { render, staticRenderFns } from "./PasswordRedPacket.vue?vue&type=template&id=fa8bde38&scoped=true&"
import script from "./PasswordRedPacket.vue?vue&type=script&lang=js&"
export * from "./PasswordRedPacket.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRedPacket.vue?vue&type=style&index=0&id=fa8bde38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8bde38",
  null
  
)

export default component.exports